<template>
  <div class="contact-details">
    <PageHeader :page-title="title">
      <template v-slot:actions>
        <b-button
          v-can-write:[isContactOwner]="$permissions.WRITE_OTHER_CONTACT"
          @click="editContact"
          variant="primary"
        >
          <span class="d-none d-sm-inline">Redigera</span>
          <i class="fas fa-edit"></i>
        </b-button>
      </template>
    </PageHeader>
    <Contact :contactId="id" />
  </div>
</template>

<script>
import PageHeader from "@/layouts/components/PageHeader.vue";
import { BButton } from "bootstrap-vue";
import Contact from "@/components/Contact.vue";
import { mapGetters } from "vuex";

export default {
  name: "contact-details",
  props: ["id", "title"],
  components: {
    PageHeader,
    BButton,
    Contact,
  },
  computed: {
    ...mapGetters(["getCurrentContact"]),
    isContactOwner: function() {
      const contact = this.getCurrentContact;
      return contact && contact.id == this.id;
    },
  },
  methods: {
    editContact() {
      this.$router.push({
        name: "contact-add",
        params: { contactId: this.id, isNew: false },
      });
    },
  },
};
</script>

<style></style>
